module.exports = __webpack_public_path__ + "img/table_head.b607909f.png";